import React from 'react'

const Footer = () => {
  return (
    <footer className="bg-dark text-light py-3">
      <p className="text-center">
      copyright &copy; MyTodoList.com
      </p>

    </footer>
  )
}

export default Footer
